var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context-item",on:{"click":function($event){$event.stopPropagation();return _vm.handleClick($event)}}},[_c('div',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"ml-auto gray-500"},[_vm._v(_vm._s(_vm.shortcut))])])}
var staticRenderFns = []

export { render, staticRenderFns }